import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import "../../styles.css";
import { Button, Image, Input, Select, TimePicker } from "antd";
import { ProfileShopDetailSchema } from "../validationSchema";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import UpdatedProfile from "../../modals/UpdatedProfile";
import { InputBox } from "../CustomWidgets/InputBox";
import { useTranslation } from "react-i18next";
import UploadMediaonly from "../upload-imageonly";
import {
  RetailerShopImagesUpload,
  ShopImageUpload,
  UpdateRetailerDetails,
} from "../../API  Functions/ProfileFunctions";
import { uploadImage } from "../../API  Functions/InventoryFunctions";
import LoadingSpinner from "../Loading";
import { checkPermission } from "../../Utils/permissionHelper";
import moment from "moment";

const ShopLocation = ({ payload, data }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";
  const [showUpdatedProfile, setShowUpdatedProfile] = useState(false);
  const [restricted, setrestricted] = useState(true);
  const [loading, setLoading] = useState(false);
  const [allMethods, setAllMethods] = useState([]);
  const [selectedMethods, setSelectedMethods] = useState([]);


  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );

  useEffect(() => {
    if (data) {

      formik?.setValues({
        street: data?.retailer_details?.shop_address?.street || "",
        street_2: data?.retailer_details?.shop_address?.street2 || "",
        city: data?.retailer_details?.shop_address?.city || "",
        governate: data?.retailer_details?.shop_address?.state || "",
        zipcode: data?.retailer_details?.shop_address?.zip || "",
        country: data?.retailer_details?.shop_address?.country || "",
        longitude: data?.retailer_details?.longitude || "",
        latitude: data?.retailer_details?.latitude || "",
        prepration_time: data?.retailer_details?.order_preperation_time || "00:00",
        minimum_order_value: data?.retailer_details?.min_order_value || 0,
      });

      const methodFromAPI = data?.retailer_details?.payment_method || "COD";
      const matchedMethod = allMethods.find((m) => m.apiValue === methodFromAPI);
      if (matchedMethod) {
        setSelectedMethods([matchedMethod]);
      }

      setrestricted(true);

    }
  }, [data, allMethods]);

  const formik = useFormik({
    initialValues: {
      street: data?.retailer_details?.shop_address?.street || "",
      street_2: data?.retailer_details?.shop_address?.street2 || "",
      city: data?.retailer_details?.shop_address?.city || "",
      governate: data?.retailer_details?.shop_address?.state || "",
      zipcode: data?.retailer_details?.shop_address?.zip || "",
      country: data?.retailer_details?.shop_address?.country || "",
      longitude: data?.retailer_details?.longitude || "",
      latitude: data?.retailer_details?.latitude || "",
      prepration_time: data?.retailer_details?.order_preperation_time || "00:00",
      minimum_order_value: data?.retailer_details?.min_order_value || 0,
    },

    // validationSchema: ProfileShopDetailSchema,
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: async (values) => {
      if (!checkPermission("/settings/profile", isGinne)) {
        return;
      }
      setLoading(true)
      try {

        const payload = {
          user_id: user_id,
          street: values.street,
          street_2: values.street_2,
          city: values.city,
          longitude: values.longitude,
          latitude: values.latitude,
          order_preperation_time: values.prepration_time,
          min_order_value: Number(values.minimum_order_value),
          payment_method: selectedMethods[0]?.apiValue || "COD",
        };
        const response = await UpdateRetailerDetails(payload);

        if (response?.status === "Update Successfully") {
          setShowUpdatedProfile(true);
          setrestricted(true);
          setLoading(false)
        }
      } catch (error) {
        console.error("Error during submission:", error);
      }
    },
  });




  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting form...");

    if (formik.errors && Object.keys(formik.errors).length > 0) {
      console.log("Formik errors:", formik.errors);
      return;
    }

    formik.handleSubmit();
  };


  useEffect(() => {
    const methods = [
      { id: 1, name: "COD", apiValue: "COD" },
      { id: 2, name: "COD & BANK", apiValue: "COD_BANK" },
    ];
    setAllMethods(methods);

    // ✅ Default to COD if nothing from API yet
    setSelectedMethods([methods[0]]);
  }, []);




  const convertTo12HourFormat = (time24) => {
    if (time24 === "24:00") {
      return "12:00 AM";
    }
    const [hours, minutes] = time24.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${String(minutes).padStart(2, "0")} ${period}`;
  };

  const convertTo24HourFormat = (time12) => {
    const [timePart, period] = time12.split(" ");
    const [hours, minutes] = timePart.split(":").map(Number);
    let hours24 = hours;
    if (period === "PM" && hours < 12) {
      hours24 = hours + 12;
    } else if (period === "AM" && hours === 12) {
      hours24 = 0;
    }
    return `${String(hours24).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };


  const togglePaymentMethod = (methodObj) => {
    setSelectedMethods([methodObj]); // ✅ always only one selected
    setrestricted(false);
  };





  return (
    <>
      {loading && <LoadingSpinner />}
      <form onSubmit={handleSubmit} className="h-120vh">
        <div className=" text-[17px] font-medium mt-6 mx-7">
          {t("Address & Location")}
        </div>
        <div className="font-normal text-[14px] text-[#5C5C5C] grid grid-cols-2 gap-x-9 mx-7 ">
          <div className="w-[363px] md:w-full  leading-[0px]">
            <InputBox
              name="street"
              label={t("street")}
              placeholder="street"
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.street}

            />
          </div>
          <div className="flex gap-x-4">
            <div className="w-[170px] md:w-full leading-[0px]">
              <InputBox
                name="governate"
                backgroundColor={"#EBEBEB"}
                label={t("Governate")}
                placeholder="Governate"
                className="text-[#5C5C5C] mt-4 h-10"
                onChange={(val) => {
                  formik.handleChange(val);
                  setrestricted(false);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.governate}

                disabled
              />
            </div>
            <div className="w-[180px] md:w-full h-[89px] leading-[0px]">
              <InputBox
                name="zipcode"
                backgroundColor={"#EBEBEB"}
                label={t("zip")}
                className="text-[#5C5C5C] mt-4 h-10"
                placeholder="zip"
                onChange={(val) => {
                  formik.handleChange(val);
                  setrestricted(false);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.zipcode}

                disabled
              />
            </div>
          </div>
          <div className="w-[363px] md:w-full leading-[0px]">
            <InputBox
              name="street_2"
              label={t("Street 2")}
              placeholder="Street 2"
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.street_2}

            />
          </div>

          <div className="w-[363px] md:w-full leading-[0px] ">
            <InputBox
              className="text-[#5C5C5C] h-10"
              name="country"
              backgroundColor={"#EBEBEB"}
              label={t("country")}
              placeholder="country"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.country}

              disabled
            />
          </div>
          <div className="w-[363px] md:w-full leading-[0px]">
            <InputBox
              label={t("city")}
              backgroundColor={"#EBEBEB"}
              className="text-[#5C5C5C] h-10"
              name="city"
              placeholder="Enter City"
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.city}

            />
          </div>
          <div className="flex gap-x-4">
            <div className="w-[180px] md:w-full leading-[0px]">
              {/* <label> {t("Latitude")}</label> */}
              <InputBox
                backgroundColor={"#EBEBEB"}
                label={t("Latitude")}
                name="latitude"
                placeholder="Latitude"
                className="text-[#5C5C5C]  h-10"
                onChange={(val) => {
                  formik.handleChange(val);
                  setrestricted(false);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.latitude}

                disabled
              />
            </div>
            <div className="w-[50px] md:w-full h-[89px] leading-[0px]">
              <InputBox
                backgroundColor={"#EBEBEB"}
                name="longitude"
                label={t("Longitude")}
                className="text-[#5C5C5C] h-10"
                placeholder="Longitude"
                onChange={(val) => {
                  formik.handleChange(val);
                  setrestricted(false);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.longitude}
                // error={formik.errors.longitude}
                // touched={formik.touched.longitude}
                disabled
              />
              <div className="mt-2 justify-end">
                <Button
                  type="button"
                  className="w-[200px] text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"

                  onClick={() => {
                    if (!checkPermission("/settings/profile", isGinne)) {
                      return;
                    }

                    if (navigator.geolocation) {
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          formik.setFieldValue("latitude", latitude);
                          formik.setFieldValue("longitude", longitude);
                          setrestricted(false);
                        },
                        (error) => {
                          console.error("Error getting location:", error);
                        }
                      );
                    } else {
                      console.error("Geolocation is not supported by this browser.");
                    }
                  }}

                >
                  {t("Get Lat & Long")}
                </Button>
              </div>
            </div>
          </div>
        </div>
    {contractType !== "Cashier" && 
    <>
      <div className=" text-[17px] font-medium mt-8 mx-7">
          {t("shop_timings")}
        </div>
        <div className="grid grid-cols-3 gap-4 mt-6 mx-7">
          {!is_lahloob && (
            <div className="w-[360px] md:w-full leading-[0px] ">
              <label className="text-[14px] text-[#5C5C5C]">
                {t("prepartion_time")}{" "}
              </label>
              <div className="mt-4">
                <TimePicker
                  format="HH:mm"
                  name="prepration_time"
                  className={`w-full border leading-none text-[#5C5C5C] text-sm rounded-md p-2 ${formik.touched.prepration_time &&
                    formik.errors.prepration_time
                    ? "border-red"
                    : "border-[#ccc]"
                    }`}
                  onChange={(time, timeString) => {
                    formik.setFieldValue("prepration_time", timeString);
                    setrestricted(false);
                  }}
                  value={
                    formik.values.prepration_time
                      ? moment(formik.values.prepration_time, "HH:mm")
                      : null
                  }
                  required
                />
                {formik.errors.prepration_time && (
                  <div className="text-red text-sm h-2 mt-0 ml-1">
                    {formik.errors.prepration_time}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="w-[300px] md:w-full leading-[0px] ">
            <label className="text-[14px] text-[#5C5C5C]">
              {t("min_order_value")}
            </label>

            <div className="relative mt-4">
              <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#5C5C5C] text-sm bg-white px-1 z-10">
                EGP
              </span>
              <Input
                style={{
                  WebkitAppearance: "none",
                  MozAppearance: "textfield",
                  paddingLeft: "3rem",
                  paddingRight: "1rem",
                }}
                type="number"
                className={`h-10 w-full bg-transparent text-[#5C5C5C] text-sm text-body outline-none focus:outline-none rounded-lg border p-3 font-[inherit] font-normal ${formik.errors.minimum_order_value ? "" : ""
                  }`}
                name="minimum_order_value"
                placeholder="Enter value"
                onChange={(val) => {
                  formik.handleChange(val);
                  setrestricted(false);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.minimum_order_value}
              />
              {formik.errors.minimum_order_value && (
                <div className="text-red text-sm h-2 mt-0 ml-1">
                  {formik.errors.minimum_order_value}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ======= Payment Methods Section ======= */}
        <div className=" text-[17px] font-medium mt-8 mx-7">
          {t("E-Order Payment Methods")}
        </div>

        <div className="flex flex-wrap mx-8 pb-6 mt-2 gap-4">
          {allMethods.map((paymentMethod) => {
            const isSelected = selectedMethods?.some(
              (item) => item.id === paymentMethod.id
            );
            return (
              <div
                key={paymentMethod.id}
                className={`flex items-center justify-center w-[160px] h-[50px] rounded-lg border cursor-pointer transition-all duration-200 shadow-sm ${isSelected
                  ? "bg-white text-primaryBlue  border-primaryBlue font-bold"
                  : "bg-white text-gray-700 border-gray-300 hover:border-primaryBlue hover:bg-blue-50"
                  }`}
                onClick={() => togglePaymentMethod(paymentMethod)}
              >
                <span className="text-sm">{t(paymentMethod.name)}</span>
              </div>
            );
          })}
        </div>
        </>
    }
      

        <div className="mt-8 mb-10 mx-7 flex gap-5">
          <button
            type="submit"
            className={`w-[180px] h-[45px] ${restricted ? "bg-primaryBluedisabled" : "bg-primaryBlue"
              } text-white rounded-lg font-semibold`}
            disabled={restricted}
          >
            {t("update_and_save")}
          </button>
          <Button
            className="w-[180px] h-[45px] text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
            onClick={() => {
              formik?.setValues({
                street: data?.retailer_details?.shop_address?.street || "",
                street_2: data?.retailer_details?.shop_address?.street2 || "",
                city: data?.retailer_details?.shop_address?.city || "",
                governate: data?.retailer_details?.shop_address?.state || "",
                zipcode: data?.retailer_details?.shop_address?.zip || "",
                country: data?.retailer_details?.shop_address?.country || "",
                longitude: data?.retailer_details?.longitude || "",
                latitude: data?.retailer_details?.latitude || "",
                prepration_time: data?.retailer_details?.order_preperation_time || "00:00",
                minimum_order_value: data?.retailer_details?.min_order_value || 0,
              });
              // Reset payment method
              const methodFromAPI = data?.retailer_details?.payment_method || "COD";
              const matchedMethod = allMethods.find((m) => m.apiValue === methodFromAPI);
              if (matchedMethod) {
                setSelectedMethods([matchedMethod]);
              }
              setrestricted(true);
            }}
          >
            {t("cancel")}
          </Button>
        </div>
      </form>
      {showUpdatedProfile && (
        <UpdatedProfile
          onClose={() => setShowUpdatedProfile(false)}
          message={t("Shop Details")}
        />
      )}
    </>
  );
};

export default ShopLocation;






// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import "../../styles.css";
// import { Button, Image, Input, Select, TimePicker } from "antd";
// import { ProfileShopDetailSchema } from "../validationSchema";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router";
// import { URLS } from "../../API/API endpoints";
// import axiosInstance from "../../AxiosInstance";
// import UpdatedProfile from "../../modals/UpdatedProfile";
// import { InputBox } from "../CustomWidgets/InputBox";
// import { useTranslation } from "react-i18next";
// import UploadMediaonly from "../upload-imageonly";
// import {
//   RetailerShopImagesUpload,
//   ShopImageUpload,
//   UpdateRetailerDetails,
// } from "../../API  Functions/ProfileFunctions";
// import { uploadImage } from "../../API  Functions/InventoryFunctions";
// import LoadingSpinner from "../Loading";
// import { checkPermission } from "../../Utils/permissionHelper";

// const ShopLocation = ({ payload, data }) => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
//   const store_id = useSelector((state) => state.login?.user?.store_id);
//   const isGinne = useSelector(
//     (state) => state?.geneLoginReducer?.isGinneLogin
//   );

//   const [showUpdatedProfile, setShowUpdatedProfile] = useState(false);
//   const [restricted, setrestricted] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [uploadBoxes, setUploadBoxes] = useState(1); // Start with one upload box
//   const [base64Images, setBase64Images] = useState([]); // State to hold multiple Base64 images
//   const company_id = useSelector(
//     (state) => state?.login?.user?.result?.company_id
//   );

//   const addUploadBox = () => {
//     if (uploadBoxes < 24) {
//       setUploadBoxes(uploadBoxes + 1);
//     }
//   };

//   //   console.log("HHHHHHHHHH", data);

//   useEffect(() => {
//     if (data) {
//       //   console.log("JADAD", data?.retailer_details?.longitude);

//       formik?.setValues({
//         street: data?.retailer_details?.shop_address?.street || "",
//         street_2: data?.retailer_details?.shop_address?.street2 || "",
//         city: data?.retailer_details?.shop_address?.city || "",
//         governate: data?.retailer_details?.shop_address?.state || "",
//         zipcode: data?.retailer_details?.shop_address?.zip || "",
//         country: data?.retailer_details?.shop_address?.country || "",
//         longitude: data?.retailer_details?.longitude || "",
//         latitude: data?.retailer_details?.latitude || "",
//       });
//       setBase64Images(new Array(25).fill(null).map(() => "")); // Initialize with empty strings
//       setUploadBoxes(data?.retailer_details?.shop_image_urls.length || 1); // Set the number of upload boxes based on existing images
//       setrestricted(true);
//       //   const initialImages = data?.retailer_details?.shop_image_urls || [];
//       //   setBase64Images(initialImages.map((url) => ({ url, base64: "" }))); // Initialize with URLs
//       //   setUploadBoxes(initialImages.length); // Set the number of upload boxes based on existing images
//     }
//   }, [data]);

//   const formik = useFormik({
//     initialValues: {
//       street: data?.retailer_details?.shop_address?.street || "",
//       street_2: data?.retailer_details?.shop_address?.street2 || "",
//       city: data?.retailer_details?.shop_address?.city || "",
//       governate: data?.retailer_details?.shop_address?.state || "",
//       zipcode: data?.retailer_details?.shop_address?.zip || "",
//       country: data?.retailer_details?.shop_address?.country || "",
//       longitude: data?.retailer_details?.longitude || "",
//       latitude: data?.retailer_details?.latitude || "",
//     },

//     // validationSchema: ProfileShopDetailSchema,
//     validateOnChange: false,
//     validateOnBlur: false,

//     onSubmit: async (values) => {
//       if (!checkPermission("/settings/profile", isGinne)) {
//         return;
//       }
//       setLoading(true)
//       try {
//         const uploadedImageUrls = []; // Array to hold the URLs of uploaded images

//         // Loop through base64Images and upload each image
//         for (let index = 0; index < base64Images.length; index++) {
//           if (base64Images[index]) {
//             const imageName = `${company_id}-${index}`; // Create the image name
//             const uploadedImageUrl = await ShopImageUpload(
//               company_id,
//               base64Images[index],
//               imageName
//             ); // Upload the image
//             console.log("uploadedImageUrl", uploadedImageUrl);

//             uploadedImageUrls.push(uploadedImageUrl); // Store the returned URL
//           }
//         }

//         // Now call the /RetailerShopImagesUpload API with the collected URLs
//         const imageUploadPayload = {
//           company_id: company_id,
//           image_urls: uploadedImageUrls,
//         };
//         console.log("imageUploadPayload", imageUploadPayload);
//         if (uploadedImageUrls) {
//           await RetailerShopImagesUpload(imageUploadPayload); // Hit the API to upload image URLs
//         }

//         const payload = {
//           user_id: user_id,
//           street: values.street,
//           street_2: values.street_2,
//           city: values.city,
//           longitude: values.longitude,
//           latitude: values.latitude,
//         };
//         const response = await UpdateRetailerDetails(payload);

//         if (response?.status === "Update Successfully") {
//           setShowUpdatedProfile(true);
//           setrestricted(true);
//           setLoading(false)
//         }
//       } catch (error) {
//         console.error("Error during submission:", error);
//       }
//     },
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault(); // Prevent default form submission behavior
//     console.log("Submitting form...");

//     // Check for validation errors
//     if (formik.errors && Object.keys(formik.errors).length > 0) {
//       console.log("Formik errors:", formik.errors);
//       return; // Prevent submission if there are errors
//     }

//     formik.handleSubmit(); // Call Formik's submit handler
//   };

//   // resetForm();
//   // },
//   //   const handleSubmit = (e) => {
//   //     formik.handleSubmit(e);
//   //   };

//   const handleurlgenerated = (values, keyname) => {
//     setrestricted(false);
//     formik.setFieldValue(keyname, values?.url);
//   };

//   // console.log("BASEEEEE", base64Images);

//   return (
//     <>
//       {loading && <LoadingSpinner />}
//       <form onSubmit={handleSubmit} className="h-120vh">
//         <div className="font-normal text-[14px] text-[#5C5C5C] grid grid-cols-2 gap-x-9 mx-7 mt-8">
//           <div className="w-[363px] md:w-full  leading-[0px]">
//             {/* <label>{t("street")}</label> */}
//             <InputBox
//               name="street"
//               label={t("street")}
//               placeholder="street"
//               onChange={(val) => {
//                 formik.handleChange(val);
//                 setrestricted(false);
//               }}
//               onBlur={formik.handleBlur}
//               value={formik.values.street}
//             //   error={formik.errors.street}
//             //   touched={formik.touched.street}
//             />
//           </div>
//           <div className="flex gap-x-4">
//             <div className="w-[170px] md:w-full leading-[0px]">
//               {/* <label> {t("Governate")}</label> */}
//               <InputBox
//                 name="governate"
//                 backgroundColor={"#EBEBEB"}
//                 label={t("Governate")}
//                 placeholder="Governate"
//                 className="text-[#5C5C5C] mt-4 h-10"
//                 onChange={(val) => {
//                   formik.handleChange(val);
//                   setrestricted(false);
//                 }}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.governate}
//                 // error={formik.errors.governate}
//                 // touched={formik.touched.governate}
//                 disabled
//               />
//             </div>
//             <div className="w-[180px] md:w-full h-[89px] leading-[0px]">
//               {/* <label>{t("zip")}</label> */}
//               <InputBox
//                 name="zipcode"
//                 backgroundColor={"#EBEBEB"}
//                 label={t("zip")}
//                 className="text-[#5C5C5C] mt-4 h-10"
//                 placeholder="zip"
//                 onChange={(val) => {
//                   formik.handleChange(val);
//                   setrestricted(false);
//                 }}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.zipcode}
//                 // error={formik.errors.zipcodes}
//                 // touched={formik.touched.zipcode}
//                 disabled
//               />
//             </div>
//           </div>
//           <div className="w-[363px] md:w-full leading-[0px]">
//             {/* <label>{t("Street 2")}</label> */}
//             <InputBox
//               name="street_2"
//               label={t("Street 2")}
//               placeholder="Street 2"
//               onChange={(val) => {
//                 formik.handleChange(val);
//                 setrestricted(false);
//               }}
//               onBlur={formik.handleBlur}
//               value={formik.values.street_2}
//             //   error={formik.errors.street_2}
//             //   touched={formik.touched.street_2}
//             />
//           </div>

//           <div className="w-[363px] md:w-full leading-[0px] ">
//             {/* <label>{t("country")}</label> */}
//             <InputBox
//               className="text-[#5C5C5C] h-10"
//               name="country"
//               backgroundColor={"#EBEBEB"}
//               label={t("country")}
//               placeholder="country"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.country}
//               //   error={formik.errors.country}
//               //   touched={formik.touched.country}
//               disabled
//             />
//           </div>
//           <div className="w-[363px] md:w-full leading-[0px]">
//             {/* <label>{t("city")}</label> */}
//             <InputBox
//               label={t("city")}
//               backgroundColor={"#EBEBEB"}
//               className="text-[#5C5C5C] h-10"
//               name="city"
//               placeholder="Enter City"
//               onChange={(val) => {
//                 formik.handleChange(val);
//                 setrestricted(false);
//               }}
//               //   onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.city}
//             //   error={formik.errors.city}
//             //   touched={formik.touched.city}
//             //   disabled
//             />
//           </div>
//           <div className="flex gap-x-4">
//             <div className="w-[180px] md:w-full leading-[0px]">
//               {/* <label> {t("Latitude")}</label> */}
//               <InputBox
//                 backgroundColor={"#EBEBEB"}
//                 label={t("Latitude")}
//                 name="latitude"
//                 placeholder="Latitude"
//                 className="text-[#5C5C5C]  h-10"
//                 onChange={(val) => {
//                   formik.handleChange(val);
//                   setrestricted(false);
//                 }}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.latitude}
//                 // error={formik.errors.latitude}
//                 // touched={formik.touched.latitude}
//                 disabled
//               />
//             </div>
//             <div className="w-[50px] md:w-full h-[89px] leading-[0px]">
//               {/* <label>{t("Longitude")}</label> */}
//               <InputBox
//                 backgroundColor={"#EBEBEB"}
//                 name="longitude"
//                 label={t("Longitude")}
//                 className="text-[#5C5C5C] h-10"
//                 placeholder="Longitude"
//                 onChange={(val) => {
//                   formik.handleChange(val);
//                   setrestricted(false);
//                 }}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.longitude}
//                 // error={formik.errors.longitude}
//                 // touched={formik.touched.longitude}
//                 disabled
//               />
//               <div className="mt-2 justify-end">
//                 <Button
//                   type="button"
//                   className="w-[200px] text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
//                   // onClick={() => {
//                   //   if (navigator.geolocation) {
//                   //     navigator.geolocation.getCurrentPosition(
//                   //       (position) => {
//                   //         const { latitude, longitude } = position.coords;
//                   //         formik.setFieldValue("latitude", latitude);
//                   //         formik.setFieldValue("longitude", longitude);
//                   //         setrestricted(false);
//                   //       },
//                   //       (error) => {
//                   //         console.error("Error getting location:", error);
//                   //       }
//                   //     );
//                   //   } else {
//                   //     console.error(
//                   //       "Geolocation is not supported by this browser."
//                   //     );
//                   //   }
//                   // }}
//                   onClick={() => {
//                     if (!checkPermission("/settings/profile", isGinne)) {
//                       return;
//                     }

//                     if (navigator.geolocation) {
//                       navigator.geolocation.getCurrentPosition(
//                         (position) => {
//                           const { latitude, longitude } = position.coords;
//                           formik.setFieldValue("latitude", latitude);
//                           formik.setFieldValue("longitude", longitude);
//                           setrestricted(false);
//                         },
//                         (error) => {
//                           console.error("Error getting location:", error);
//                         }
//                       );
//                     } else {
//                       console.error("Geolocation is not supported by this browser.");
//                     }
//                   }}

//                 >
//                   {t("Get Lat & Long")}
//                 </Button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* <div className="font-medium text-xl mx-7 mt-20 flex flex-row justify-between">
//           {t("shop_photos")}
//           <div className="">
//             <Button
//               type="button"
//               // onClick={addUploadBox}
//               onClick={() => {
//                 if (checkPermission("/settings/profile", isGinne)) {
//                   addUploadBox();
//                 }
//               }}
//               className="bg-primaryBlue text-white font-semibold rounded-lg"
//             >
//               {t("Add More")} +
//             </Button>
//           </div>
//         </div> */}


//         {/* <div className="grid grid-cols-3 gap-5 mx-7 mt-4 font-normal text-sm">
//           {[...Array(uploadBoxes)].map((_, index) => (
//             <div key={index} className="w-full">
//               <label className="text-[#5C5C5C]">
//                 {t("Shop Photo")} {`${index + 1}`}
//               </label>
//               <div className="rounded-lg border border-inset border-gray-900/25 px-2 mt-3 py-3 flex justify-center">
//                 <div
//                   className="flex flex-col items-center justify-center"
//                   style={{ minHeight: 100, maxHeight: 100 }}
//                 >
//                   <div className="flex  text-sm leading-6 text-gray-600">
//                     {data?.retailer_details?.shop_image_urls[index] ? (
//                       <Image
//                         src={data.retailer_details.shop_image_urls[index]} // Use the URL from formik
//                         height={100}
//                         width={100}
//                         alt="Image"
//                         style={{
//                           objectFit: "cover", // Ensures the image covers the box without distortion
//                           minWidth: "100%",
//                           maxWidth: "100%",
//                           maxHeight: "100%",
//                           borderRadius: "8px", // Optional: Add some border radius for aesthetics
//                         }}
//                       />
//                     ) : base64Images[index] ? (
//                       <Image
//                         src={base64Images[index]} // Use the Base64 image if URL is not available
//                         height={100}
//                         width={100}
//                         alt="Uploaded"
//                         style={{
//                           objectFit: "cover", // Ensures the image covers the box without distortion
//                           minWidth: "100%",
//                           maxWidth: "100%",
//                           maxHeight: "100%",
//                           borderRadius: "8px", // Optional: Add some border radius for aesthetics
//                         }}
//                       />
//                     ) : (
//                       <svg
//                         className=" float-left h-10 w-12 text-gray-300"
//                         viewBox="0 0 24 24"
//                         fill="currentColor"
//                         aria-hidden="true"
//                       >
//                         <path
//                           fill-rule="evenodd"
//                           d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
//                         />
//                       </svg>
//                     )}
//                     <span
//                       className={`cursor-pointer ${base64Images[index] ? "mt-4" : "mt-0"
//                         }`}
//                     >
//                       {!data?.retailer_details?.shop_image_urls[index] && (
//                         <UploadMediaonly
//                           foldername={"store_ShopImages"}
//                           onfileAdd={`Shop_${index + 1}`}
//                           setBase64Images={(base64) => {
//                             const newImages = [...base64Images];
//                             newImages[index] = base64; // Store the base64 data at the specific index
//                             setBase64Images(newImages);
//                             setrestricted(false);
//                           }}
//                           urlgenerated={(val) => {
//                             formik.setFieldValue(
//                               `image_url_${index}`,
//                               val?.url
//                             ); // Store the URL in Formik
//                           }}
//                           imageurl={base64Images[index]?.url || ""}
//                         />
//                       )}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div> */}

//         <div className="mt-8 mb-10 mx-7 flex gap-5">
//           <button
//             type="submit"
//             className={`w-[180px] h-[45px] ${restricted ? "bg-primaryBluedisabled" : "bg-primaryBlue"
//               } text-white rounded-lg font-semibold`}
//             disabled={restricted}
//           >
//             {t("update_and_save")}
//           </button>
//           <Button
//             className="w-[180px] h-[45px] text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
//             onClick={() => {
//               formik?.setValues({
//                 street: data?.retailer_details?.shop_address?.street || "",
//                 street_2: data?.retailer_details?.shop_address?.street2 || "",
//                 city: data?.retailer_details?.shop_address?.city || "",
//                 governate: data?.retailer_details?.shop_address?.state || "",
//                 zipcode: data?.retailer_details?.shop_address?.zip || "",
//                 country: data?.retailer_details?.shop_address?.country || "",
//                 longitude: data?.retailer_details?.longitude || "",
//                 latitude: data?.retailer_details?.latitude || "",
//               });
//               //   setUploadBoxes(1);
//               setBase64Images(new Array(25).fill(null).map(() => "")); // Initialize with empty strings
//               setUploadBoxes(
//                 data?.retailer_details?.shop_image_urls.length || 1
//               );
//             }}
//           >
//             {t("cancel")}
//           </Button>
//         </div>
//       </form>
//       {showUpdatedProfile && (
//         <UpdatedProfile
//           onClose={() => setShowUpdatedProfile(false)}
//           message={t("Shop Details")}
//         />
//       )}
//     </>
//   );
// };

// export default ShopLocation;
